import { definePermission } from "./permission";
/**
 * Group abilities that are PLATFORM-level (`D52`) — not the four in-group
 * roles.
 *
 * `owner`, `admin`, `trainer` and `student` (`D50`) are per-membership and
 * live in the database, not here: what a trainer may do inside a group comes
 * from the membership row, which is what makes dismissal work by removing one
 * row (`D50`). These two are what a person may do ACROSS groups.
 */
export const GROUP_CREATE = definePermission("group:create", "Create a group.");
/**
 * Administer any group on the platform. The group's own owner and admins do
 * not need this — their authority comes from the membership.
 */
export const GROUP_MANAGE = definePermission("group:manage", "Administer any group on the platform.");
export const GROUP_PERMISSIONS = [GROUP_CREATE, GROUP_MANAGE];
//# sourceMappingURL=groups.js.map